<template>
  <div class="goal-section">
    <div class="goal-header">
      <div class="goal-title-wrap">
        <i class="el-icon-arrow-left arrow-icon" @click="changeMonthHandle(-1)"></i>
        <span class="goal-title">{{ currentMonth }}月目标</span>
        <i class="el-icon-arrow-right arrow-icon" @click="changeMonthHandle(1)"></i>
      </div>
      <span class="year-goal-link" @click="yearGoalClickHandle">
        本年目标 <i class="el-icon-arrow-right"></i>
      </span>
    </div>
    <div class="goal-cards">
      <div
        class="goal-card"
        :class="item.type"
        v-for="(item, index) in goalList"
        :key="index"
        @click="clickGoalCardHandle(item)"
      >
        <div class="goal-card-header">
          <div class="goal-tag" :class="item.type">{{ item.tag }}</div>
          <div class="goal-name">{{ item.name }}</div>
          <div class="goal-value">
            <span class="current">{{ item.finishTargetNumber }}</span>
            <span class="total">/{{ item.targetNumber }}名</span>
          </div>
        </div>
        <div class="goal-progress-wrap">
          <el-progress
            :percentage="item.percentage"
            :show-text="false"
            :stroke-width="12"
            :color="item.type === 'year' ? '#FE8F1F' : '#1890FF'"
          ></el-progress>
          <span v-if="item.completeStatus === 1" class="status-tag gap">差距{{ Math.max(0, item.targetNumber - item.finishTargetNumber) }}</span>
          <span v-else-if="item.completeStatus === 3" class="status-tag excess">超额完成！</span>
          <span v-else-if="item.completeStatus === 2" class="status-tag excess">已完成！</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoalCardListInfo',
  props: {
    currentMonth: {
      type: Number,
      default: 3
    },
    goalList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    changeMonthHandle(delta) {
      const newMonth = this.currentMonth + delta
      if (newMonth >= 1 && newMonth <= 12) {
        this.$emit('changeMonth', newMonth)
      }
    },
    clickGoalCardHandle(item) {
      this.$emit('cardClick', item)
    },
    yearGoalClickHandle() {
      this.$emit('yearGoalClick')
    }
  }
}
</script>

<style scoped lang="less">
.goal-section {
  background: #fff;
  border-radius: 4px;
  padding: 16px;

  .goal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .goal-title-wrap {
      display: flex;
      align-items: center;
      gap: 8px;

      .arrow-icon {
        padding: 2px;
        font-size: 14px;
        color: #9AA0A8;
        cursor: pointer;
        border: 1px solid #E0E0E0;
        border-radius: 2px;

        &:hover {
          color: #1890FF;
        }
      }

      .goal-title {
        font-size: 16px;
        font-weight: 600;
        color: #1F2329;
      }
    }

    .year-goal-link {
      font-size: 14px;
      color: #667182;
      cursor: pointer;

      &:hover {
        color: #1890FF;
      }

      i {
        font-size: 12px;
      }
    }
  }

  .goal-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;

    .goal-card {
      flex: 1;
      border: 1px solid #E0E0E0;
      border-radius: 4px;
      padding: 16px;
      min-width: 0;
      background-color: #F7F8F9;
      cursor: pointer;

      &.year {
        border-color: #F1E4BD;
        background-color: #FFF8E6;
      }

      &:hover {
        box-shadow: 0px 4px 12px 0px rgba(0, 20, 42, 0.15);
        border: 1px solid #1890FF;
      }

      .goal-card-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;

        .goal-tag {
          display: inline-block;
          padding: 3px 6px 4px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 500;
          background: linear-gradient(73deg, #2396FF 0%, #0276E1 100%);
          color: #FFF;

          &.year {
            background: linear-gradient(73deg, #FFB170 0%, #FF8B40 100%);
            border-radius: 2px;
          }
        }

        .goal-name {
          flex: 1;
          font-size: 14px;
          font-weight: 500;
          color: #1F2329;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .goal-value {
          font-size: 14px;
          color: #667182;

          .current {
            font-size: 20px;
            font-weight: 600;
            color: #1F2329;
          }

          .total {
            color: #667182;
          }
        }
      }

      .goal-progress-wrap {
        display: flex;
        align-items: center;
        gap: 10px;

        /deep/.el-progress {
          width: calc(100% - 100px);

          .el-progress-bar__outer {
            background-color: #fff !important;
          }
        }

        .status-tag {
          font-size: 12px;
          white-space: nowrap;

          &.excess {
            color: #FF6454;
          }

          &.gap {
            color: #9AA0A8;
          }
        }
      }
    }
  }
}
</style>
